import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import { Options } from 'react-select';
import CreatableSelect from 'react-select/creatable';

import classnames from 'classnames';

import { Option } from '@hsp/react-component-library/types';
import { formatMoney, isDefined, isEmpty, isNumber } from '@hsp/utilities';

import { onCreateOptions } from 'pages/audience/shared';
import { ITagSelectionDataPointProps } from 'types/pages/audience-builder/components';
import { s } from 'utilities/strings';

import './donation.component.scss';

const DonationHigh: FC<ITagSelectionDataPointProps> = ({ className, data, isInvalid, onValueChanged, value }) => {
  const { values } = data;
  const options = useMemo(() => {
    if (Array.isArray(values)) {
      return values.map((value) => {
        const noCap = s('Site.Pages.AudienceBuilder.Create.NoCap');

        return {
          label: value === noCap ? value : formatMoney(value, 0),
          value: value === noCap ? '' : value.toString(),
        };
      });
    }

    return [];
  }, [values]);
  const [donationHigh, setDonationHigh] = useState<Options<Option<string>>>(options);
  const handleCreateHigh = useCallback((value: string) => onCreateOptions(value, setDonationHigh), []);

  useEffect(() => {
    if (!isDefined(value) || isEmpty(value)) {
      return;
    }

    const item = donationHigh.find(({ value: itemValue }) => itemValue === value);

    if (!isDefined(item)) {
      handleCreateHigh(value.toString());
    }
  }, [donationHigh, handleCreateHigh, value]);

  return (
    <div className={classnames('rfm-donation-wrapper', className, { 'is-invalid': isInvalid })}>
      <CreatableSelect
        createOptionPosition="first"
        menuPlacement="auto"
        onChange={(option) => {
          onValueChanged?.(option?.value);
        }}
        onCreateOption={(controlValue) => {
          if (isNumber(controlValue)) {
            handleCreateHigh(controlValue);
            onValueChanged?.(controlValue);
          }
        }}
        options={donationHigh}
        placeholder={s('Site.High')}
        value={donationHigh.find((option) => option.value === value) ?? null}
      />
    </div>
  );
};

export default DonationHigh;
